import React from 'react'

export default function RoomQuote({roomQuote}) {
  return (
    <>
    <section className="roomdetail-content">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-11">
                    <div className="wow animate__animated animate__slideInUp" data-wow-delay="0.1s" data-wow-duration="1.1s">
                        <p>{roomQuote.content}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
